import { Injectable } from '@angular/core';
import {
    ConfirmationModel,
    ENDPOINTS,
    NotificationIdState,
    NotificationStateUtilities,
    ODataObject,
    OdataService,
} from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OdataConfirmationService {
    public constructor(private readonly odataService: OdataService) {}

    public saveConfirmation(confirmation: ConfirmationModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            confirmation,
            ENDPOINTS.NotificationConfirmation,
            confirmation.notificationIdentifier.toString(),
        );
    }

    /**
     * The NgRx counterpart of {@link saveConfirmation}, for a caller that already built the payload —
     * NgRx effects, whose actions cannot carry model instances.
     *
     * @param outModel the confirmation's complete OData payload
     * @param notificationId the notification the confirmation belongs to
     */
    public saveConfirmationOutModel(outModel: ODataObject, notificationId: NotificationIdState): Observable<unknown> {
        return this.odataService.deepInsertOutModelRequest(
            outModel,
            ENDPOINTS.NotificationConfirmation,
            NotificationStateUtilities.notificationIdToString(notificationId),
        );
    }
}
